import type { ReactNode } from 'react';
import { OfflineIndicator } from '@/shared/components/OfflineIndicator';
// Dark-mode toggle temporarily hidden (2026-11-04) -- the gradient/white-card
// treatment introduced during the brand refresh hasn't been designed for a
// dark variant yet. Not deleted: re-enable by uncommenting this import, the
// useTheme() call below, and the toggle button in the JSX once that's sorted.
// import { useTheme } from './providers/ThemeProvider';
import { useAuth } from './providers/AuthProvider';
import { BottomNav } from './BottomNav';
import './AppShell.css';

export function AppShell({ children }: { children: ReactNode }) {
  // const { theme, toggleTheme } = useTheme();
  const { user, logout } = useAuth();

  return (
    <div className="app-shell">
      <header className="app-shell__topbar">
        <div className="app-shell__brand">
          <img src="/brand/logo-alt.png" alt="The Foot & Ankle Show" className="app-shell__logo" />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <OfflineIndicator />

          {/*
          <button
            type="button"
            onClick={toggleTheme}
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            style={{
              background: 'none',
              border: 'none',
              color: '#ffffff',
              fontSize: '1.125rem',
              cursor: 'pointer',
              minWidth: 44,
              minHeight: 44
            }}
          >
            {theme === 'dark' ? '☀' : '☾'}
          </button>
          */}

          {user && (
            <button
              type="button"
              onClick={() => void logout()}
              title={`Log out (${user.firstName} ${user.lastName})`}
              style={{
                background: 'rgba(255, 255, 255, 0.15)',
                border: 'none',
                color: '#ffffff',
                fontSize: '0.875rem',
                fontWeight: 600,
                cursor: 'pointer',
                minHeight: 44,
                padding: '0 14px',
                borderRadius: 'var(--radius-full)'
              }}
            >
              Log out
            </button>
          )}
        </div>
      </header>

      <main className="app-shell__main">{children}</main>

      <BottomNav />
    </div>
  );
}